import {
  getSsoProviderLabel,
  type ResolvedEnterpriseProvider
} from "../../loginModel";
import { AuthButton } from "../AuthButton";
import { AuthCardFooter, AuthFooterAction } from "../AuthCardFooter";

type Props = {
  providers: ResolvedEnterpriseProvider[];
  /** The firm requires SSO; hide the password fallback. */
  enforceSso: boolean;
  onStartSso: (provider: ResolvedEnterpriseProvider) => void;
  onUsePassword: () => void;
};

/** Firm single sign-on: one button per configured identity provider. */
export function SsoStep({
  providers,
  enforceSso,
  onStartSso,
  onUsePassword
}: Props) {
  return (
    <>
      <div className="flex flex-col gap-3">
        {providers.length > 0 ? (
          providers.map((provider) => (
            <AuthButton
              key={provider.provider_id}
              fullWidth
              onClick={() => onStartSso(provider)}
            >
              {getSsoProviderLabel(provider)}
            </AuthButton>
          ))
        ) : (
          <p className="text-base leading-5 text-ink-muted">
            No SSO providers are configured for this firm.
          </p>
        )}
      </div>

      {!enforceSso && (
        <AuthCardFooter>
          <AuthFooterAction onClick={onUsePassword}>
            Use Password Instead
          </AuthFooterAction>
        </AuthCardFooter>
      )}
    </>
  );
}
